import { useCallback, useContext, useMemo, useState } from "react";
import {
    IPixApiProviderDepositResponseData,
    IDepositResponse,
} from "@finbackoffice/clientbff-client";
import { DepositStatus, PixApiProvider } from "@finbackoffice/enums";
import { PixWalletDataContext } from "./pix-wallet-data.provider";

export const TOOLTIP_HIDE_TIMEOUT = 3000;

export const useSecondStepDeposit = () => {
    const { depositData, setDepositStep, setDepositData } = useContext(PixWalletDataContext);
    const [isTooltipVisible, setTooltipVisible] = useState<boolean>(false);
    const depositAddress = useMemo(() => {
        const providerData = depositData?.provider_data as IPixApiProviderDepositResponseData;
        return providerData.pix_api_provider === PixApiProvider.Paybrokers ||
            providerData.pix_api_provider === PixApiProvider.WyraPay ||
            providerData.pix_api_provider === PixApiProvider.StarsPay
            ? depositData?.deposit?.meta.qr_code_location
            : depositData?.deposit?.meta.qr_code;
    }, [depositData]);

    const handleCopy = useCallback(() => {
        setTooltipVisible(true);
        void navigator.clipboard.writeText(depositAddress || "");
        setTimeout(() => {
            setTooltipVisible(false);
        }, TOOLTIP_HIDE_TIMEOUT);
    }, [depositAddress]);

    const onSocketUpdate = useCallback(
        (deposit: IDepositResponse, error: any) => {
            if (error) {
                console.error(error);
                return;
            }

            if (deposit.id !== depositData?.deposit?.id) {
                return;
            }
            if (
                deposit.status === DepositStatus.Approved ||
                deposit.status === DepositStatus.Rejected
            ) {
                setDepositStep("complete");
                setDepositData({
                    ...depositData,
                    deposit: { ...depositData?.deposit, ...deposit },
                });
            }
        },

        [depositData, setDepositStep, setDepositData],
    );

    return useMemo(
        () => ({
            isTooltipVisible,
            depositAddress,
            handleCopy,
            onSocketUpdate,
        }),
        [isTooltipVisible, depositAddress, handleCopy, onSocketUpdate],
    );
};
